import { Component, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SnackNotifier } from '@app/shared/notifier/snack-notifier';
import { Navigate } from '@ngxs/router-plugin';
import { AuthActions } from '@app/modules/auth/store/auth.actions';
import { IRegistrationConfirm } from '@app/modules/auth/interface/registration-confirm';
import { UserModel } from '@app/modules/user/model/user';
import { UserState } from '@app/modules/user/store/user.state';

@Component({ templateUrl: './registration-confirm.component.html' })
export class RegistrationConfirmPageComponent implements OnInit, OnDestroy {
  public get user(): UserModel {
    return this.store.selectSnapshot(UserState.model);
  }

  private _subscription = new Subscription();
  /**
   * @param store
   * @param actions
   * @param snack
   */
  constructor(
    private readonly store: Store,
    private readonly actions: Actions,
    private readonly snack: SnackNotifier,
  ) {}

  public ngOnInit(): void {
    if (!this.user.email) {
      this.store.dispatch(new Navigate(['/auth/registration']));
    }

    this.subscribeOnRegistrationConfirmSuccess();
    this.subscribeOnRegistrationConfirmFailed();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public confirm(value: IRegistrationConfirm): void {
    this.store.dispatch(new AuthActions.RegistrationConfirm(value));
  }

  private subscribeOnRegistrationConfirmSuccess(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.RegistrationConfirmSuccess))
        .subscribe(() => {
          this.snack.success('Registration successfully confirmed!');
          this.store.dispatch(new Navigate(['/auth/login']));
        }),
    );
  }

  private subscribeOnRegistrationConfirmFailed(): void {
    this._subscription.add(
      this.actions
        .pipe(ofActionDispatched(AuthActions.RegistrationConfirmFailed))
        .subscribe(({ error }) => this.snack.error(error)),
    );
  }
}
